<template>
  <div>
    <h3
      style="text-transform: uppercase; margin-bottom: 12px; margin-top: 28px;"
    >
      Campaign Status
    </h3>
    <form @submit.prevent="changeStatus()">
      <div>
        <div class="form-group">
          <select
            v-model="status"
            id="status"
            name="status"
            class="form-control"
            required
          >
            <option
              v-for="statusItem in statuses"
              v-bind:key="statusItem"
              v-bind:value="statusItem"
            >
              {{ statusItem }}
            </option>
          </select>
          <label style="letter-spacing: 0px; font-size: 12px;">Status:</label>
        </div>
        <div class="form-group">
          <input
            type="text"
            name="note"
            id="note"
            class="form-control"
            v-model="note"
            required
          />
          <label style="letter-spacing: 0px; font-size: 12px;"
            ><span style="color: red;">*&nbsp;</span>Note:</label
          >
        </div>
      </div>
      <button
        class="btn btn-primary"
        style="padding: 0px 10px;border-radius: 0px; height: 35px;"
        :disabled="!canUpdate"
      >
        Update
      </button>
    </form>
  </div>
</template>

<script>
import CampaignServiceV2 from '../../services/V2/CampaignServiceV2';

export default {
  data() {
    return {
      note: null,
      originalStatus: null,
    };
  },
  props: ['id', 'status'],
  computed: {
    statuses() {
      return ['Booked', 'Cancelled', 'In Progress', 'Finished'];
    },
    canUpdate() {
      const valueChanged = this.originalStatus !== this.status;

      return valueChanged && this.note;
    },
  },
  methods: {
    async changeStatus() {
      try {
        const confirmed = await this.$swal({
          type: 'warning',
          title: 'Update Status?',
          text: `Are you sure you want to update this campaign's status to "${
            this.status
          }"?`,
          showCancelButton: true,
          confirmButtonText: 'Yes',
        });

        if (confirmed && confirmed.dismiss) {
          return;
        }

        const response = await CampaignServiceV2.changeStatus(this.id, {
          status: this.status,
          note: this.note,
        });

        if (response.status === 207) {
          this.$swal({
            type: 'success',
            title: 'Warning: Campaign Updated With Issues',
            text:
              'The campaign status was updated internally, but encountered an issue with the Signifi API. Please reach out to Signifi support.',
          });
        } else if (response.status === 200) {
          this.$swal({
            type: 'success',
            title: 'Success!',
            text: 'Campaign status updated successfully!',
          });
        }

        this.note = '';

        this.$emit('on-campaign-status-changed');
        this.originalStatus = this.status;
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Error',
          text: 'Failed to update campaign.',
        });
      }
    },
  },
  mounted() {
    this.originalStatus = this.status;
  },
};
</script>
